import mapProps from 'map-props';
import { formValues } from 'redux-form';
import { SelectField } from 'components/forms/Select';
import { FUEL_TYPE_NAME } from '../../../../../../constants';
import propsMapping from './propsMapping';

export default formValues({ value: FUEL_TYPE_NAME })(
  mapProps(propsMapping)(SelectField),
);
